import { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getPrimaryNavigation } from '@/config/navigation';
import { useNavScroll } from '@/hooks/useNavScroll';

export default function Nav() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const scrolled = useNavScroll(100);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const navItems = getPrimaryNavigation(t).filter(item => !item.cta);

  return (
    <>
      {/* Preloader */}
      <div className="preloader" style={{ display: loaded ? 'none' : 'flex' }}>
        <div className="loading-container">
          <div className="loading"></div>
          <div id="loading-icon"><img src="/images/loader.svg" alt="" /></div>
        </div>
      </div>

      <header className={`main-header ${scrolled ? 'header-sticky-active' : ''}`}>
        <div className="header-sticky">
          <nav className="container">
            <div className="navbar navbar-expand-lg" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {/* Logo */}
              <Link className="navbar-brand" to="/" style={{ flexShrink: 0, marginRight: '40px' }}>
                <img
                  src="/images/mgc-logo-footer.png"
                  alt="MGC Homes"
                  style={{ height: '50px', width: 'auto', display: 'block' }}
                />
              </Link>

              {/* Main Menu */}
              <div className="collapse navbar-collapse main-menu" style={{ justifyContent: 'flex-end' }}>
                <div className="nav-menu-wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginLeft: 'auto' }}>
                  <ul className="navbar-nav" id="menu" style={{ display: 'flex', alignItems: 'center', margin: 0, padding: 0, listStyle: 'none' }}>
                    {navItems.map(item => (
                      <li key={item.to} className="nav-item" style={{ display: 'inline-block' }}>
                        <NavLink 
                          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'} 
                          to={item.to}
                          style={({ isActive }) => ({
                            color: '#fff',
                            position: 'relative',
                            ...(isActive ? {} : {})
                          })}
                        >
                          {item.label}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                  {/* Header Btn */}
                  <div className="header-btn d-inline-flex" style={{ marginLeft: '20px' }}>
                    <Link to="/contact" className="btn-default">{t('nav.getInTouch')}</Link>
                  </div>
                </div>
              </div>

              {/* Mobile Toggle */}
              <div className="navbar-toggle">
                <button
                  className={`slicknav_btn ${open ? 'slicknav_open' : ''}`}
                  onClick={() => setOpen(!open)}
                  aria-label={t('nav.menu')}
                >
                  <span className="slicknav_menutxt"></span>
                  <span className="slicknav_icon slicknav_no-text">
                    <span className="slicknav_icon-bar"></span>
                    <span className="slicknav_icon-bar"></span>
                    <span className="slicknav_icon-bar"></span>
                  </span>
                </button>
              </div>
            </div>
          </nav>

          {/* Responsive Menu */}
          {open && (
            <div className="responsive-menu">
              <div className="slicknav_menu">
                <ul className="slicknav_nav">
                  {navItems.map(item => (
                    <li key={item.to} className="nav-item">
                      <Link className="nav-link" to={item.to} onClick={() => setOpen(false)}>
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      </header>
    </>
  );
}
